// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const hr: KnowledgePagesCopy = {
  knowledgePage: 'Stranica znanja',
  knowledgePages: 'Stranice znanja',
  featureOffTitle: 'Stranice znanja nisu omogućene u ovom radnom prostoru.',
  featureOffBody: 'Kontekst tvrtke i izvori i dalje su u odjeljku Znanje.',
  loadingPage: 'Učitavanje stranice…',
  loadingSuggestion: 'Učitavanje prijedloga…',
  cancel: 'Odustani',
  tryAgain: 'Pokušaj ponovno',
  everyoneIn: 'Svi u {company}',
  yourCompany: 'vašoj tvrtki',
  revision: 'Revizija {n}',
  openRevision: 'Otvori reviziju {n}',
  pageCount: 'one:stranica|few:stranice|other:stranica',
  topicCount: 'one:tema|few:teme|other:tema',
  sectionCount: 'one:odjeljak|few:odjeljka|other:odjeljaka',
  lineCount: 'one:redak|few:retka|other:redaka',
  documentCount: 'one:dokument|few:dokumenta|other:dokumenata',
  changeCount: 'one:promjena|few:promjene|other:promjena',
  newPageCount: 'one:nova stranica|few:nove stranice|other:novih stranica',
  changedPageCount:
    'one:promijenjena stranica|few:promijenjene stranice|other:promijenjenih stranica',
  otherSectionCount: 'one:drugi odjeljak|few:druga odjeljka|other:drugih odjeljaka',
  characterCount: 'one:znak|few:znaka|other:znakova',
  diffStats: 'Promijenjeno: {sections} · dodano: {added} · uklonjeno: {removed}',
  diffMatchesBase: 'Predloženi tekst podudara se s osnovnom revizijom.',
  diffIntroduction: 'Uvod',
  diffOtherUnchanged: '{sections} bez promjena.',
  timeJustNow: 'upravo sada',
  originImportedFrom: 'Uvezeno iz {path}',
  originImportedFromCommit: 'Uvezeno iz {path} @ {commit}',
  authorityApprovedInPoneva: 'Odobreno u sustavu Poneva',
  authorityImported: 'Uvezeno',
  authorityInRepository: '{canonicality} u repozitoriju',
  authorityVerified: 'provjereno {date}',
  authorRepositoryImport: 'Uvoz iz repozitorija',
  authorSuggestedInChat: 'Prijedlog iz razgovora',
  authorSuggestedInChatWith: 'Prijedlog iz razgovora s korisnikom {name}',
  authorSuggestedBy: 'Prijedlog: {name}',
  authorSuggestedByApp: 'Prijedlog povezane aplikacije',
  authorSuggestedByColleague: 'Prijedlog kolege',
  authorSuggestedByYou: 'Vaš prijedlog',
  authorSuggestedOnBehalf: 'Prijedlog aplikacije {app} u ime korisnika {name}',
  authorSuggestedByAppOnBehalf: 'Prijedlog povezane aplikacije u ime korisnika {name}',
  authorSuggestedAndApproved: 'Predložio i odobrio: {name}',
  approverApprovedBy: 'odobrenje: {name}',
  approverAppliedBy: 'primjena: {name}',
  kindCreatePage: 'Nova stranica',
  kindUpdatePage: 'Predložena izmjena',
  kindArchivePage: 'Arhiviranje',
  statusConflict: 'Sukob · stranica se promijenila',
  statusPending: 'Čeka pregled',
  statusApproved: 'Odobreno',
  statusRejected: 'Odbačeno',
  statusWithdrawn: 'Povučeno',
  statusSuperseded: 'Zamijenjeno',
  errRevisionConflict: 'Ova se stranica promijenila dok ste je pregledavali.',
  errProposalChanged:
    'Ovaj se prijedlog promijenio dok ste ga pregledavali. Prije odluke pregledajte najnoviju verziju.',
  errPublishRequired: 'Samo urednici tvrtke mogu odobravati izmjene znanja ili uvoziti stranice.',
  errProposalLimit:
    'Vaša tvrtka već ima 200 prijedloga koji čekaju pregled. Pregledajte neke prije novih prijedloga.',
  errAuthorLimit:
    'Već imate 50 prijedloga koji čekaju pregled. Prije novih prijedloga pričekajte da se o nekima odluči ili povucite neke.',
  errImportProposalLimit:
    'Ovaj bi uvoz dodao više promijenjenih stranica za pregled nego što stane u red za pregled vaše tvrtke (najviše 200). Odlučite o nekim prijedlozima u kartici Za pregled, a zatim ponovno primijenite uvoz.',
  errImportChanged:
    'Ovo nije uvoz koji ste pregledali. Ponovno ga otvorite i pregledajte prije primjene.',
  errImportItemNotFound: 'Ovaj dokument više nije dio uvoza.',
  errIdempotencyConflict:
    'Ovaj je prijedlog već poslan s drukčijim sadržajem. Ponovno učitajte i pokušajte ponovno.',
  errImportHashMismatch:
    'Datoteka u ovoj snimci ne odgovara zabilježenom kontrolnom zbroju. Izradite novu snimku i pokušajte ponovno.',
  errImportAlreadyApplied: 'Ovaj je uvoz već primijenjen.',
  errImportDiscarded: 'Ovaj je uvoz odbačen. Ponovno odaberite datoteku snimke.',
  errImportDuplicateItem: 'Ova snimka dvaput navodi isti dokument. Ponovno izradite snimku.',
  errInvalidImport:
    'Poneva nije mogla prihvatiti ovu snimku. Izradite novu skriptom za snimku i pokušajte ponovno.',
  errInvalidInput: 'Poneva nije mogla prihvatiti ovaj unos. Provjerite polja i pokušajte ponovno.',
  errImportLimit:
    'Previše je uvoza pripremljeno, a nije primijenjeno. Primijenite ili odbacite neke prije pripreme novog.',
  errPageTooLarge: 'Stranica je veća od 256 KB. Podijelite je na manje stranice.',
  errTooManySections: 'Stranica ima više od 2000 naslova. Podijelite je na manje stranice.',
  errPageLimit: 'Vaša je tvrtka dosegla ograničenje od 2000 stranica znanja.',
  errCollectionLimit: 'Vaša je tvrtka dosegla ograničenje od 100 tema.',
  errProposalNotPending: 'O ovom je prijedlogu već odlučeno. Prikazani status je aktualan.',
  errRequesterRemoved:
    'Osoba koja je ovo predložila više nije u ovoj tvrtki pa se prijedlog ne može odobriti.',
  errRevisionAlreadyCurrent: 'Ta je revizija već trenutačna.',
  errPageArchived:
    'Ova je stranica arhivirana dok ste je pregledavali. Prije odluke ponovno pregledajte prijedlog.',
  errAlreadyArchived: 'Ova je stranica već arhivirana.',
  errProposalForbidden: 'Samo osoba koja je ovo predložila može povući prijedlog.',
  errUnavailable: 'Stranice znanja trenutačno nisu dostupne.',
  errTimeout: 'Poneva je predugo odgovarala.',
  errItemTooLarge: 'Datoteka {path} veća je od 256 KB. Podijelite je na manje stranice.',
  errItemTooManySections:
    'Datoteka {path} ima više od 2000 naslova. Podijelite je na manje stranice.',
  errItemHashMismatch:
    'Datoteka {path} ne odgovara zabilježenom kontrolnom zbroju. Izradite novu snimku i pokušajte ponovno.',
  errNoLongerAvailable: 'Ova vam stavka više nije dostupna.',
  errTooLargeToSend: 'Ova je datoteka prevelika za slanje.',
  cardChecking: 'Provjera statusa…',
  cardNotAvailable: 'Nije dostupno',
  cardStatusUnavailable: 'Status nije dostupan',
  cardUnshowable: 'Ovu predloženu izmjenu znanja nije moguće prikazati.',
  cardEyebrow: 'Predložena izmjena znanja',
  cardLabel: 'Predložena izmjena znanja · {title}',
  cardMissing: 'Ovaj vam prijedlog više nije dostupan.',
  cardUnknown:
    'Nismo mogli provjeriti stanje ovog prijedloga. Otvorite pregled da biste vidjeli njegov status.',
  cardCheckAgain: 'Provjeri ponovno',
  cardReview: 'Pregledaj izmjenu',
  statusLineApproved: 'Odobreno razumijevanje',
  readyCount:
    'one:spreman za pretraživanje|few:spremna za pretraživanje|other:spremno za pretraživanje',
  preparingCount: 'one:u pripremi|few:u pripremi|other:u pripremi',
  attentionCount: 'one:treba pažnju|few:trebaju pažnju|other:treba pažnju',
  topicsExplore: 'Istraži temu',
  topicsAllPages: 'Sve stranice',
  topicsOpenPages: 'Otvori Stranice',
  topicsEmpty:
    'Još nema odobrenih stranica. Stranice sadrže opsežno razumijevanje tvrtke s cjelovitom poviješću revizija.',
  reviewsTitle: 'Predložene izmjene stranica',
  reviewsTitleMine: 'Vaše predložene izmjene stranica',
  reviewsIntro:
    'Svaki je prijedlog cjelovita kandidatska revizija s razlogom i dokazima. Ništa se ne mijenja dok ne odobrite upravo tu reviziju.',
  reviewsIntroMine:
    'Vaši prijedlozi čekaju ovdje dok ih urednik tvrtke ne pregleda. Do tada stranice ostaju nepromijenjene.',
  loadPagesFailed: 'Nismo mogli učitati stranice znanja.',
  loadProposalsFailed: 'Nismo mogli učitati predložene izmjene stranica.',
  loadMoreFailed: 'Nismo mogli učitati više stranica.',
  otherPages: 'Ostale stranice',
  loadTopicFailed: 'Nismo mogli učitati ovu temu.',
  revisionShort: 'r{n}',
  updatedOn: 'Ažurirano {date}',
  emptyTitle: 'Još nema stranica znanja.',
  emptyBody:
    'Stranice sadrže odobreno, opsežno razumijevanje vaše tvrtke — smjer, odluke i načine rada — uz čuvanje svake revizije. Uvezite ih iz snimke repozitorija ili započnite stranicu u razgovoru; urednik odobrava svaku stranicu prije nego što postane znanje tvrtke.',
  importFromSnapshot: 'Uvezi iz snimke repozitorija',
  startInChat: 'Započni stranicu u razgovoru',
  startInChatPrompt:
    'Pomozi mi započeti stranicu znanja za našu tvrtku. Pitaj me što treba obuhvatiti i nemoj izmišljati sadržaj. Ostaje prijedlog dok je urednik tvrtke ne odobri.',
  loadingPages: 'Učitavanje stranica znanja…',
  filterLabel: 'Filtriraj stranice po naslovu',
  filterPlaceholder: 'Filtriraj stranice',
  importButton: 'Uvezi',
  showingTopic: 'Prikazuje se tema {topic}',
  showAllTopics: 'Prikaži sve teme',
  loadingTopic: 'Učitavanje teme…',
  noMatch: 'Nijedna stranica ne odgovara upitu „{filter}”.',
  topicNoPages: 'U ovoj temi još nema odobrenih stranica.',
  loading: 'Učitavanje…',
  loadMore: 'Učitaj još stranica',
  metaApproved: 'odobreno {date}',
  metaRepositoryAuthoritative: 'repozitorij ostaje mjerodavan',
  loadPageFailed: 'Nismo mogli učitati ovu stranicu.',
  loadHistoryFailed: 'Nismo mogli učitati povijest revizija.',
  outlineLabel: 'Odjeljci stranice',
  outlineToggle: 'Na ovoj stranici',
  loadingHistory: 'Učitavanje povijesti revizija…',
  historyLabel: 'Povijest revizija',
  historyIntro:
    'Svaka se odobrena revizija čuva. Vraćanjem ranije revizije stvara se prijedlog za pregled; kasnije se revizije nikad ne brišu.',
  historyCurrent: 'Trenutačna',
  historyViewing: 'Prikazuje se',
  historyView: 'Prikaži',
  historyViewAria: 'Prikaži reviziju {n}',
  restoreAria: 'Vrati kao prijedlog: revizija {n}',
  restoreCreating: 'Stvaranje prijedloga…',
  restore: 'Vrati kao prijedlog',
  restoreUnconfirmed:
    'Nismo mogli potvrditi da je prijedlog stvoren. Prije novog pokušaja provjerite karticu Za pregled.',
  editTooLarge:
    'Ova je stranica veća od 256 KB. Prije nego što je predložite, podijelite je na manje stranice.',
  editConflict:
    'Ova se stranica promijenila dok ste je uređivali. Kopirajte svoj tekst, otvorite najnoviju reviziju i ponovno predložite izmjenu.',
  editUnconfirmed:
    'Nismo mogli potvrditi da je vaš prijedlog poslan. Prije ponovnog slanja provjerite karticu Za pregled.',
  editHeading: 'Predloži izmjenu',
  editIntro:
    'Uređujete reviziju {n}. Urednik tvrtke pregledava točnu izmjenu prije nego što postane revizija {next}; do tada stranica ostaje nepromijenjena.',
  editOutdated:
    'Dok ste uređivali, odobrena je novija revizija. Kopirajte svoj tekst, a zatim počnite ponovno od najnovije revizije kako se ne bi izgubilo ništa što je ona promijenila.',
  editContentLabel: 'Sadržaj stranice (Markdown)',
  editReasonLabel: 'Zašto ova izmjena?',
  editReasonPlaceholder: 'Što se promijenilo i odakle to potječe.',
  editSending: 'Slanje…',
  editSend: 'Pošalji na pregled',
  editDiscardConfirm: 'Odbaciti ovu izmjenu? Ništa od onoga što ste promijenili nije poslano.',
  editNoChanges: 'Još nema izmjena.',
  editNeedsContent: 'Stranica mora imati sadržaj.',
  exportFailed: 'Nismo mogli izvesti ovu stranicu. Pokušajte ponovno.',
  askPagePrompt: 'Pitanje o stranici znanja „{title}” (revizija {n}, {link}):',
  askPageSectionPrompt: 'Pitanje o stranici znanja „{title}” § {section} (revizija {n}, {link}):',
  pageMissingTitle: 'Ova stranica nije dostupna.',
  pageMissingBody: 'Možda je arhivirana ili više nemate pristup znanju ove tvrtke.',
  pageArchived: 'Arhivirano',
  viewingRevisionCurrent: 'Pregledavate reviziju {n}; trenutačna revizija je {current}.',
  viewingRevisionOld: 'Pregledavate reviziju {n}. To nije trenutačna revizija.',
  openCurrent: 'Otvori trenutačnu',
  archivedBanner:
    'Ova je stranica arhivirana. Više ne utječe na odgovore; njezina se povijest čuva.',
  pageViewsLabel: 'Prikazi stranice',
  tabRead: 'Čitanje',
  tabHistory: 'Povijest',
  unknownSection: 'Povezani odjeljak nije dio ove revizije. Prikazuje se cijela stranica.',
  askAboutPage: 'Pitaj o ovoj stranici',
  exporting: 'Izvoz…',
  exportMarkdown: 'Izvezi Markdown',
  loadSuggestionFailed: 'Nismo mogli učitati ovaj prijedlog.',
  evidenceSource: 'Izvor',
  evidenceFact: 'Kontekst tvrtke',
  evidenceResult: 'Spremljeni rad',
  evidenceUrl: 'Web-stranica',
  evidenceDecision: 'Odluka',
  evidenceReference: 'Referenca',
  evidenceOpenPage: 'Otvori stranicu znanja',
  evidenceOpenSource: 'Otvori izvor',
  evidenceOpenFact: 'Otvori kontekst tvrtke',
  evidenceOpenResult: 'Otvori spremljeni rad',
  evidenceOpenUrl: 'Otvori web-stranicu',
  evidenceOpenDecision: 'Otvori odluku',
  evidenceOpenReference: 'Otvori referencu',
  evidenceDecisionNote:
    'Zabilježena odluka. U sustavu Poneva nema ničega što bi se moglo otvoriti.',
  evidenceFactGone: 'Ovaj kontekst tvrtke više nije spremljen.',
  evidencePageNoRevision: 'Ova stranica nema odobrenu reviziju koja bi se mogla otvoriti.',
  evidencePrivateExcerpt: 'Privatni dokaz — podijeljen je samo gornji isječak.',
  evidencePrivate: 'Privatni dokaz — njegov sadržaj nije podijeljen s vama.',
  evidenceHeading: 'Dokazi',
  evidenceNone: 'Nisu priloženi dokazi. Procijenite gornji razlog sam za sebe.',
  changeAdded: 'Dodano',
  changeRemoved: 'Uklonjeno',
  changeChanged: 'Promijenjeno',
  changeUnchanged: 'Nepromijenjeno',
  moreLineCount: 'one:dodatni redak|few:dodatna retka|other:dodatnih redaka',
  moreUnchangedLineCount:
    'one:dodatni nepromijenjeni redak|few:dodatna nepromijenjena retka|other:dodatnih nepromijenjenih redaka',
  unchangedLineCount:
    'one:nepromijenjeni redak|few:nepromijenjena retka|other:nepromijenjenih redaka',
  skipAdded: '{lines} — prikazano u cjelovitoj reviziji',
  skipRemoved: 'Uklonjeno: {lines}',
  cutUnchanged: 'Nije prikazano: {lines}',
  cutChanged: 'Nije prikazano: {lines}, {changes}. Provjerite ih u cjelovitoj reviziji.',
  cutAddedRemoved: 'dodano {added} i uklonjeno {removed}',
  cutAdded: 'dodano {added}',
  cutRemoved: 'uklonjeno {removed}',
  lineAddedSr: 'Dodano:',
  lineRemovedSr: 'Uklonjeno:',
  noLinesAdded: 'Novi odjeljak. Njegov je tekst u cjelovitoj reviziji u nastavku.',
  noLinesRemoved: 'Ovaj bi se odjeljak uklonio sa stranice.',
  noLinesChanged: 'Ovaj se odjeljak mijenja. Njegov je tekst u cjelovitoj reviziji u nastavku.',
  diffHeading: 'Promjene',
  outcomeArchived: 'Arhivirano.',
  outcomeArchivedBody:
    'Stranica {title} više ne utječe na odgovore i uklonjena je s popisa stranica. Njezine revizije, ovaj prijedlog i odluka ostaju u povijesti stranice.',
  openArchivedPage: 'Otvori arhiviranu stranicu',
  outcomeApproved: 'Odobreno.',
  outcomeApprovedRevision: 'Revizija {n} sada je odobrena verzija stranice {title}.',
  outcomeApprovedPlain: 'Ovaj je prijedlog odobren.',
  outcomeRestored: 'Stranica je ponovno na popisu stranica i opet utječe na odgovore.',
  outcomeKept: 'Prijedlog, odluka i sve ranije revizije ostaju u povijesti stranice.',
  openPage: 'Otvori stranicu',
  outcomeDismissed: 'Odbačeno.',
  outcomeWithdrawn: 'Povučeno.',
  outcomeSuperseded: 'Zamijenjeno.',
  outcomeSupersededBody:
    'Novija revizija, prijedlog ili uvoz iz repozitorija učinili su ovaj prijedlog zastarjelim. Sam po sebi nije ništa promijenio.',
  outcomeUnchanged: 'Stranica ostaje nepromijenjena.',
  approveNewPage: 'Odobri novu stranicu',
  approveArchive: 'Odobri arhiviranje',
  approveRestoreRevision: 'Vrati i odobri reviziju {n}',
  approveRevision: 'Odobri reviziju {n}',
  approveArchiveNote: 'Odobravanjem se ova stranica arhivira za sve u {company}.',
  approvePublishNote: 'Odobravanjem se ova revizija objavljuje za sve u {company}.',
  approvePublishEvidenceNote:
    'Odobravanjem se ova revizija i gore prikazani isječci dokaza objavljuju za sve u {company}.',
  archivedTitle: 'Ova je stranica arhivirana.',
  alreadyArchivedBody:
    'Odobravanje ne bi ništa promijenilo pa se ovaj prijedlog može samo odbaciti.',
  archivedRestoreBody:
    'Odobravanjem se stranica vraća: s ovom se revizijom vraća na popis stranica, u pretraživanje i odgovore.',
  staleRevisionAction: 'Usporedi s najnovijom verzijom',
  staleProposalTitle: 'Ovaj se prijedlog promijenio dok ste ga pregledavali.',
  staleProposalAction: 'Pregledaj najnoviju verziju',
  staleArchivedTitle:
    'Ova je stranica arhivirana dok ste je pregledavali. Odobravanjem ovog prijedloga vratila bi se.',
  staleArchivedAction: 'Pregledaj ponovno',
  suggestionMissingTitle: 'Ovaj prijedlog nije dostupan.',
  suggestionMissingBody:
    'Možda je povučen ili pripada nekom drugom i nije poslan na pregled u tvrtki.',
  decideUnconfirmed:
    'Nismo mogli potvrditi vašu odluku. Prikazani status najnoviji je iz sustava Poneva; provjerite ga prije novog pokušaja.',
  decideFailed: 'Nismo mogli spremiti vašu odluku.',
  discussPrompt: 'Pomozi mi doraditi predloženu izmjenu znanja za „{title}” ({link}).',
  conflictBody:
    'Ovaj je prijedlog napisan prema reviziji {base}; trenutačna revizija je {current}. Odobravanjem bi se ta promjena prebrisala pa se prijedlog ne može odobriti u ovom obliku.',
  conflictBodyPlain:
    'Ovaj je prijedlog napisan prema ranijoj reviziji pa se ne može odobriti u ovom obliku.',
  openLatest: 'Otvori najnoviju verziju',
  reworkInChat: 'Preradi u razgovoru',
  factReason: 'Razlog',
  factNoReason: 'Razlog nije naveden.',
  factAudience: 'Publika',
  factRevision: 'Revizija',
  revisionNew: 'Nova stranica, revizija 1',
  revisionArchiveAfter: 'Arhiviranje nakon revizije {n}',
  revisionWrittenAgainst: 'Napisano prema reviziji {base}; trenutačna revizija je {current}',
  revisionCurrentToProposed: 'Trenutačna revizija {base} → predložena revizija {next}',
  revisionProposed: 'Predložena revizija {next}',
  proposedPage: 'Predložena stranica',
  archivingHeading: 'Što arhiviranje znači',
  archivingBody:
    'Stranica prestaje utjecati na odgovore i uklanja se s popisa stranica. Njezine revizije i ova odluka se čuvaju.',
  noComparison: 'Usporedba odjeljaka nije dostupna za ovaj prijedlog.',
  showComplete: 'Prikaži cjelovitu reviziju',
  approving: 'Odobravanje…',
  dismissing: 'Odbacivanje…',
  dismiss: 'Odbaci',
  withdrawing: 'Povlačenje…',
  withdraw: 'Povuci',
  editInChat: 'Uredi u razgovoru',
  waitingForPublisher: 'Čeka da ga urednik tvrtke pregleda.',
  snapshotTooLarge: 'Ova je snimka veća od 8 MB. Izradite je s manje dokumenata.',
  snapshotNotSnapshot:
    'Ova datoteka nije snimka znanja. Odaberite JSON datoteku koju je zapisala skripta za snimku.',
  snapshotEmpty: 'Ova snimka ne sadrži dokumente.',
  readDocumentFailed: 'Nismo mogli pročitati ovaj dokument. Pokušajte ponovno.',
  readingDocument: 'Čitanje dokumenta…',
  hideText: 'Sakrij tekst',
  readText: 'Pročitaj tekst',
  textOf: 'Tekst: {title}',
  gitSnapshot: 'Git snimka {commit}',
  repositorySnapshot: 'Snimka repozitorija',
  importNewHeading: '{pages} · odobreno kad primijenite',
  importNewNote:
    'Svaka se objavljuje kao odobrena stranica za sve u {company}, bez daljnjeg pregleda. Pročitajte svaku prije primjene.',
  importChangedHeading: '{pages} · poslano na pregled',
  importChangedNote:
    'Svaka postaje predložena izmjena. Njezina se stranica mijenja tek kad je urednik odobri u kartici Za pregled, koja prikazuje što se promijenilo.',
  unchangedDocumentCount:
    'one:nepromijenjeni dokument|few:nepromijenjena dokumenta|other:nepromijenjenih dokumenata',
  unchangedNote:
    'Oni se već podudaraju sa svojim odobrenim stranicama. Za njih se ništa ne zapisuje.',
  stagedHeading: 'Pripremljeno, ali nije primijenjeno',
  excludedSummary: 'Izostavljeno iz ove snimke: {documents}',
  countsLine: '{newPages} · {changedPages} za pregled · {unchanged} nepromijenjeno',
  importAlreadyDiscarded: 'Ovaj je uvoz već odbačen.',
  confirmLabel: 'Potvrdi uvoz',
  unchangedKeepCount:
    'one:nepromijenjeni dokument zadržava svoju stranicu|few:nepromijenjena dokumenta zadržavaju svoje stranice|other:nepromijenjenih dokumenata zadržava svoje stranice',
  confirmBody:
    'Primijeniti ovaj uvoz za sve u {company}? Kao revizija 1 odobrit će se: {newPages}; na pregled će čekati: {changedPages}; a {unchanged}. Raniji prijedlozi uvoza za te stranice bit će povučeni.',
  applying: 'Primjena…',
  applyImport: 'Primijeni uvoz',
  chooseAnother: 'Odaberi drugu datoteku',
  allCurrent: 'Sve u ovoj snimci već je ažurno.',
  importApplied: 'Uvoz je primijenjen.',
  appliedSummary: 'Stvoreno: {pages} · čeka pregled: {changes} · nepromijenjeno: {unchanged}.',
  appliedIndexing:
    'Nove stranice postaju pretražive u razgovoru kad indeksiranje završi. Napredak je vidljiv u pripremi izvora.',
  openPages: 'Otvori stranice',
  reviewChanges: 'Pregledaj: {changes}',
  checkIndexing: 'Provjeri napredak indeksiranja',
  sendSnapshotFailed: 'Nismo mogli poslati ovu snimku. Pokušajte ponovno.',
  openStagedFailed: 'Nismo mogli otvoriti ovaj pripremljeni uvoz.',
  applyUnconfirmed:
    'Nismo mogli potvrditi je li uvoz primijenjen. Prije novog pokušaja provjerite karticu Stranice.',
  applyFailed: 'Nismo mogli primijeniti ovaj uvoz.',
  importHeading: 'Uvoz stranica iz repozitorija',
  backToPages: 'Natrag na stranice',
  importLead:
    'Izradite snimku naredbom {command}, a zatim odaberite datoteku. Prije nego što se išta spremi, vidjet ćete svaki dokument i što bi promijenio.',
  snapshotFileLabel: 'Datoteka snimke znanja',
  readingSnapshot: 'Čitanje snimke…',
  openingStaged: 'Otvaranje pripremljenog uvoza…',
  chooseSnapshot: 'Odaberi datoteku snimke',
  factOrigin: 'Podrijetlo',
  factContents: 'Sadržaj',
  importOnlyListed: 'Uvoze se samo ovdje navedeni dokumenti.',
  importRepositoryAuthoritative:
    'Repozitorij ostaje mjerodavan; promijenjeni dokumenti postaju prijedlozi za pregled.',
  overviewReviewChanges: 'Pregledaj promjene',
  overviewConnectAgents: 'Poveži vanjske agente',
  overviewEyebrow: 'Zajedničko razumijevanje',
  overviewTitle: '{company} u kontekstu.',
  overviewLeadFallback:
    'Znanje vaše tvrtke počinje kontekstom koji dijelite. Zajedno izgradite razumijevanje svojeg poslovanja.',
  overviewBody:
    'Poneva iz konteksta tvrtke i izvornih materijala dobiva polazište — ne sve što se može znati o tvrtki {company}. Nastavite graditi to razumijevanje kako se vaše poslovanje razvija.',
  overviewAskPrompt: 'Što znaš o našoj tvrtki i što bi bilo korisno dodati?',
  overviewAsk: 'Pitaj o tvrtki {company}',
  overviewAddSources: 'Dodaj izvore',
  contextEyebrow: 'Što odgovorima daje kontekst',
  contextTitle: 'Poslovanje iza pitanja.',
  contextBody:
    'Izvori s web-stranica objašnjavaju javni dio poslovanja. Bilješke tvrtke dodaju vašu terminologiju, prioritete i način rada.',
  contextPrompt:
    'Pomozi mi razjasniti prioritete tvrtke i radne preferencije koje bismo trebali zapamtiti.',
  contextAction: 'Izgradi naše razumijevanje',
  learnEyebrow: 'Prostor za učenje',
  learnTitle: 'Počnite s onim što je sljedeće važno.',
  learnBody:
    'Dodajte izvorne materijale ili pojasnite kako vaša tvrtka radi. Poneva može predložiti trajne izmjene koje ćete pregledati.',
  learnPrompt:
    'Na temelju postojećeg znanja naše tvrtke, koje važne informacije nedostaju za posao koji želimo obaviti?',
  learnAction: 'Razgovaraj o tome što bi bilo korisno',
  canvasEmptyTitle: 'Malo konteksta puno znači.',
  canvasEmptyBody:
    'Profil vaše tvrtke polazna je točka. Dodajte izvorne materijale i pregledane bilješke kako bi Poneva bolje razumjela vaš rad.',
  pageEyebrow: 'Radni prostor tvrtke {company}',
  pageTitle: 'Znanje tvrtke',
  pageDescription: 'Izvori i razumijevanje na kojima Poneva temelji svoj rad.',
  tabOverview: 'Sažetak',
  tabPages: 'Stranice',
  tabSources: 'Izvori',
  tabReview: 'Za pregled',
  proposalApproved: 'Odobreni kontekst tvrtke',
  proposalDismissed: 'Odbačeni prijedlog',
  proposalRemoval: 'Predloženo uklanjanje',
  proposalCorrection: 'Predloženi ispravak',
  proposalContext: 'Predloženi kontekst tvrtke',
  proposalCurrent: 'Trenutačno razumijevanje',
  proposalFactGone:
    'Spremljena činjenica više nije dostupna. Osvježite znanje tvrtke prije pregleda ovog uklanjanja.',
  proposalReviewFallback: 'Pregledajte predloženi kontekst tvrtke.',
  proposalNotSaved: 'Još nije spremljeno. Originalni izvori ostaju nepromijenjeni.',
  proposalWaiting: 'Čeka pregled · urednik tvrtke odlučuje u odjeljku Pristigla pošta',
  proposalSaving: 'Spremanje…',
  proposalApproveRemoval: 'Odobri uklanjanje',
  proposalApproveClarification: 'Odobri pojašnjenje',
  factLabel: 'Činjenica o tvrtki',
  factEyebrow: 'Činjenica · Svi u {company}',
  factSuggestCorrection: 'Predloži ispravak',
  factAskPrompt: 'Pomozi mi razumjeti ili pojasniti ovaj spremljeni kontekst tvrtke: „{content}”',
  factAsk: 'Pitaj o tome',
  companyContextHeading: 'Kontekst tvrtke',
  companyContextPrompt:
    'Želim pojasniti znanje naše tvrtke. Pomozi mi pregledati što znamo i predložiti izmjenu.',
  companyContextEmpty:
    'Još nema odobrenih bilješki. Započnite razgovor o svojoj tvrtki ili dodajte izvorni materijal u nastavku.',
  refineInChat: 'Doradi u razgovoru',
  reviewPanelLabel: 'Promjene znanja za pregled',
  suggestedUpdatesHeading: 'Predložene izmjene',
  suggestedUpdatesIntro:
    'Prijedlozi iz vaših razgovora. Vi odlučujete što postaje dio trajnog znanja vaše tvrtke.',
  reviewEmptyTitle: 'Ništa ne čeka vaš pregled.',
  reviewEmptyBody:
    'Kad Poneva predloži promjenu znanja vaše tvrtke, pronaći ćete je ovdje. Za trajne promjene uvijek je potrebno vaše odobrenje.',
  reviewEmptyPrompt:
    'Pomozi mi pregledati znanje naše tvrtke i predloži što bi bilo korisno sljedeće pojasniti.',
  inclusionPendingApproval: 'Promjena uključivanja u znanje poslana je na odobrenje.',
  sourcesFileIncluded: 'Datoteka je uključena u pretraživanje znanja za svoju trenutačnu publiku.',
  sourcesAddFailed: 'Nije moguće dodati ovaj izvor.',
  sourcesHeading: 'Materijal na kojem se temelje odgovori.',
  sourcesIntro:
    'Poneva pretražuje cjelokupni izvorni materijal, a ne samo sažetak. Čuvajte izvornike, pogledajte što je spremno i odaberite što oblikuje vaše odgovore.',
  addSourceHeading: 'Dodajte materijal svoje tvrtke',
  addSourceIntro:
    'Preneseni izvori ostaju privatni u vašoj Knjižnici i utječu samo na vaše odgovore. Odaberite Dijeli kad ih želite učiniti dostupnima kolegama.',
  uploadSource: 'Prenesi izvor',
  addSourcePrompt:
    'Pomozi mi dodati izjavu tvrtke kao zajednički interni izvor. Pitaj me što želim zabilježiti; nemoj izmišljati sadržaj. Za trajne promjene razumijevanja tvrtke i dalje je potrebno moje odobrenje.',
  addThroughChat: 'Dodaj putem razgovora',
  addingSource: 'Dodavanje…',
  addToKnowledge: 'Dodaj u znanje',
  uploadFormats: 'TXT, Markdown, CSV i JSON · Do 5 MB po datoteci',
  sourceExcluded: 'Isključeno iz odgovora',
  sourcePreparationFailed: 'Priprema nije uspjela',
  sourcePreparing: 'Priprema za pretraživanje',
  sourceWaiting: 'Čeka pripremu',
  sourceReadinessUnknown: 'Spremnost nije dostupna',
  sourceRetryQueued: 'Priprema je u redu čekanja. Spremnost će se ažurirati kad završi.',
  sourceIncludedNotice: 'Izvor je uključen. Poneva će ga pripremiti za pretraživanje.',
  sourceExcludedNotice: 'Isključeno iz odgovora. Originalni izvor je sačuvan.',
  sourceUpdateFailed: 'Ovaj izvor nije moguće ažurirati.',
  sourceOriginalMaterial: 'Originalni izvorni materijal',
  sourceDiscuss: 'Raspravi u razgovoru',
  sourceDiscussPrompt: 'Pomozi mi razumjeti ili pojasniti „{title}”.',
  sourceExclude: 'Isključi iz odgovora',
  sourceInclude: 'Uključi u odgovore',
  sourcesLoadFailed: 'Nismo mogli učitati vaše izvore.',
  sourceLibraryLabel: 'Knjižnica izvora tvrtke',
  sourceListCaption: 'Originalni izvori · uključeni i isključeni',
  sourceSearchLabel: 'Pretraži izvore tvrtke',
  sourceSearchPlaceholder: 'Pretražite svoje izvore…',
  sourcesFinding: 'Traženje vaših izvora…',
  sourcePagesLabel: 'Straničenje izvora',
  sourceRange: '{from}–{to} od {count}',
  sourceCount: 'one:izvor|few:izvora|other:izvora',
  sourcePrevious: 'Prethodno',
  sourceNext: 'Dalje',
  sourceNoMatchTitle: 'Nema odgovarajućih izvora.',
  sourceNoMatchBody: 'Pokušajte s drugim izrazom ili nazivom izvora.',
  sourceEmptyTitle: 'Dajte svojim pitanjima čvršće polazište.',
  sourceEmptyBody:
    'Dodajte dokumente tvrtke, podatke o proizvodima ili radne bilješke. Poneva može koristiti cjelokupni izvorni materijal u razgovorima i Skillsima.',
  indexCheckFailed: 'Nismo mogli provjeriti pripremu izvora.',
  indexRetryQueued:
    'Neuspjeli unosi znanja stavljeni su u red za pripremu. Vaš izvorni materijal nije promijenjen.',
  indexQueueFailed: 'Nismo mogli staviti pripremu u red čekanja. Pokušajte ponovno.',
  indexPreparing: 'Pripremamo novo znanje za vaše razgovore…',
  indexAttention: 'Dio znanja treba pažnju.',
  queuing: 'Stavljanje u red…',
  retryPreparation: 'Ponovi pripremu',
  sourceKindStatement: 'Izjava tvrtke',
  sourceKindWebsite: 'Web-stranica',
  sourceKindDocument: 'Dokument',
  factAnswers: 'one:odgovor|few:odgovora|other:odgovora',
  factUsedThisWeek: 'Korišteno ovaj tjedan: {answers}',
  factLastUsed: 'zadnje korišteno: {when}',
  factToday: 'danas',
  factYesterday: 'jučer',
  factImpact: 'Ova promjena utječe na činjenicu korištenu ovaj tjedan ({answers}).',
  factCorrectionAbout: 'O ovoj činjenici o tvrtki: „{content}” ({link})',
  factCorrectionOutdated: 'Ovo više nije točno:',
  sourceCanvasRecorded: 'Zabilježeni izvorni materijal',
  sourceCanvasNotIncluded:
    'Nije uključeno u znanje tvrtke. Izvornik se čuva za referencu i još se može upotrijebiti u određenom razgovoru.',
  sourceCanvasOpenOriginal: 'Otvori izvornik',
  sourceCanvasUnavailable: 'Sadržaj izvora nije dostupan.',
  sourceCanvasDiscussPrompt: 'Pomozi mi razumjeti ili pojasniti „{title}”.',
  sourceCanvasDiscuss: 'Raspravi o ovom izvoru',
  sourceCanvasCorrectionNote:
    'Ispravak postaje predloženi kontekst tvrtke. Zabilježeni izvor ostaje nepromijenjen.',
  contextCanvasEyebrow: 'Dostupni kontekst tvrtke',
  contextCanvasTitle: 'Znanje iza ovog razgovora.',
  contextCanvasBody:
    'Odobreno razumijevanje i izvorni materijali koje je dodala vaša tvrtka. Dostupno u razgovoru i u alatu Skills.',
  contextCanvasOpen: 'Otvori Znanje',
};

export default hr;
